// @flow
import React, { useContext } from 'react';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { CREDITS_AND_BURSTS_ENABLED_BACKEND_NAME } from '../../constants';
import { BooleanSelectField } from '../../formik-utils/FormFields';
import { getIfUserIsAdminBasedOnGivenDetails } from '../../common-utils/utils';
import { UserContext } from '../../contexts/UserContext';

export const CreditsAndBurstsEnabledContainer = () => {
  const user = useContext(UserContext);
  const isUserAdmin = getIfUserIsAdminBasedOnGivenDetails(user);

  const creditsAnBurstsEnabledEnabledConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(
    CREDITS_AND_BURSTS_ENABLED_BACKEND_NAME
  );

  return (
    <BooleanSelectField
      disabled={!isUserAdmin}
      fieldDisplayName={creditsAnBurstsEnabledEnabledConfig.displayName}
      fieldName={creditsAnBurstsEnabledEnabledConfig.backendFieldName}
    />
  );
};
